const hero = (): void => {
  const classes = {
    highlightActive: 'highlight--active',
    heroSectionmodalPopUpToggleActive: 'hero__video-modal-toggle--active',
    heroSectionmodalPopUpToggleAccordionOpen:
      'hero__video-modal-toggle--accordion-open',
  };

  const selectors = {
    heroSection: '[data-hero]',
    heroSectionActiveAttr: 'data-hero-active',
    heroSectionToggles: '[data-hero-toggle]',
    heroSectionToggleTarget: 'data-hero-toggle',
    heroSectionVideo: '[data-hero-video]',
    heroSectionVideoAttr: 'data-hero-video',
    heroSectionmodalPopUpToggle: '[data-hero-video-modal-toggle]',
    heroSectionmodalAccordionToggle: '[data-hero-video-modal-accordion-toggle]',
    heroSectionMediaContainers: '[data-media-container]',
    heroSectionVideoAccordion: '[data-hero-video-accordion]',
  };

  const heroSections = document.querySelectorAll<HTMLElement>(
    selectors.heroSection
  );

  const isMobile = (): boolean => {
    return window.innerWidth <= 768 || 'ontouchstart' in window;
  };

  const openAccordion = (accordionInner: HTMLElement): void => {
    accordionInner.style.maxHeight = accordionInner.scrollHeight + 'px';
  };

  const closeAccordion = (accordionInner: HTMLElement): void => {
    accordionInner.style.maxHeight = null as any;
  };

  heroSections.forEach((section) => {
    const toggles = section.querySelectorAll(selectors.heroSectionToggles);
    // const videos = section.querySelectorAll<HTMLVideoElement>(
    //   selectors.heroSectionVideo
    // );

    toggles.forEach((toggle) => {
      const handleToggle = (): void => {
        toggles.forEach((otherToggle) => {
          otherToggle.classList.remove(classes.highlightActive);
        });

        const target =
          toggle.getAttribute(selectors.heroSectionToggleTarget) || '';

        toggle.classList.add(classes.highlightActive);

        section.setAttribute(selectors.heroSectionActiveAttr, target);

        // videos.forEach((video) => {
        //   video.pause();

        //   if (video.getAttribute(selectors.heroSectionVideoAttr) == target) {
        //     video.play();
        //   }
        // });
      };

      if (isMobile()) {
        toggle.addEventListener('click', handleToggle);
      } else {
        toggle.addEventListener('mouseover', handleToggle);
      }
    });

    const mediaContainers = section.querySelectorAll(
      selectors.heroSectionMediaContainers
    );

    mediaContainers.forEach((media, index: number) => {
      const handleMediaHover = (): void => {
        section.setAttribute(selectors.heroSectionActiveAttr, `${index + 1}`);

        toggles.forEach((toggle) => {
          if (
            toggle.getAttribute(selectors.heroSectionToggleTarget) ==
            `${index + 1}`
          ) {
            toggle.classList.add(classes.highlightActive);
          } else {
            toggle.classList.remove(classes.highlightActive);
          }
        });

        // videos.forEach((video) => {
        //   video.pause();

        //   if (
        //     video.getAttribute(selectors.heroSectionVideoAttr) == `${index + 1}`
        //   ) {
        //     video.play();
        //   }
        // });
      };

      if (isMobile()) {
        media.addEventListener('click', handleMediaHover);
      } else {
        media.addEventListener('mouseover', handleMediaHover);
      }
    });

    section.addEventListener('mouseleave', () => {
      section.setAttribute(selectors.heroSectionActiveAttr, '');
    });

    // Video

    const modalPopUpToggle = section.querySelector(
      selectors.heroSectionmodalPopUpToggle
    );
    const heroSectionmodalAccordionToggle = section.querySelector(
      selectors.heroSectionmodalAccordionToggle
    );

    if (modalPopUpToggle) {
      modalPopUpToggle.querySelector('span')?.addEventListener('click', () => {
        modalPopUpToggle.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });

        if (
          modalPopUpToggle.classList.contains(
            classes.heroSectionmodalPopUpToggleActive
          )
        ) {
          modalPopUpToggle.querySelector('video')?.pause();
        } else {
          setTimeout(() => {
            modalPopUpToggle.querySelector('video')?.play();
          }, 800);
        }

        setTimeout(() => {
          modalPopUpToggle.classList.toggle(
            classes.heroSectionmodalPopUpToggleActive
          );
        }, 500);
      });
    }

    if (heroSectionmodalAccordionToggle) {
      heroSectionmodalAccordionToggle
        .querySelector('span')
        ?.addEventListener('click', () => {
          const accordionContent = document.querySelector<HTMLElement>(
            selectors.heroSectionVideoAccordion
          );

          heroSectionmodalAccordionToggle.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });

          if (accordionContent) {
            setTimeout(() => {
              if (accordionContent.style.maxHeight) {
                closeAccordion(accordionContent);

                heroSectionmodalAccordionToggle.classList.remove(
                  classes.heroSectionmodalPopUpToggleAccordionOpen
                );

                accordionContent.querySelector('video')?.pause();
              } else {
                openAccordion(accordionContent);

                heroSectionmodalAccordionToggle.classList.add(
                  classes.heroSectionmodalPopUpToggleAccordionOpen
                );

                accordionContent.querySelector('video')?.play();
              }
            }, 500);
          }
        });
    }
  });
};

export default hero;